module.exports = __webpack_public_path__ + "img/d87b2a15-4729-5246-c3c9-d7cdd837bc80.5fd751df.png";